import React, {useCallback, useEffect, useState} from 'react'
import {Button} from '@consta/uikit/Button'
import {IconAdd} from '@consta/uikit/IconAdd'
import {IconDocExport} from '@consta/uikit/IconDocExport'

import GridCliffList from './component/grid.cliff.list'
import ModalCliffView from './component/modal.cliff.cliffView'
import './cliff.css'
import {isBusinessAdmin} from '../../service/authAccess'


type CliffViewMode = 'active' | 'all'

const PageCliff = () => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [updateKey, setUpdateKey] = useState(0)
    const [exportKey, setExportKey] = useState(0)
    const [viewMode, setViewMode] = useState<CliffViewMode>('active')
    const [summary, setSummary] = useState({total: 0, active: 0})
    const canCreateCliff = !isBusinessAdmin()

    useEffect(() => {
        document.title = 'АСПО.Контроль | Обрывы'
    }, [])

    const handleSummaryChange = useCallback((value: {total: number, active: number}) => {
        setSummary(value)
    }, [])

    const handleModalClose = (updated: boolean) => {
        setIsModalOpen(false)
        if (updated) {
            setUpdateKey((value) => value + 1)
        }
    }

    return (
        <div className="cliff-page">
            <header className="cliff-page-header">
                <div>
                    <h1>Обрывы</h1>
                    <p>Учёт инструмента в скважинах и истории извлечения</p>
                </div>
                <div className="cliff-page-actions">
                    {canCreateCliff && (
                        <Button
                            label="Добавить обрыв"
                            iconRight={IconAdd}
                            size="s"
                            onClick={() => setIsModalOpen(true)}
                        />
                    )}
                    <Button
                        label="Экспорт"
                        iconRight={IconDocExport}
                        size="s"
                        view="secondary"
                        onClick={() => setExportKey((value) => value + 1)}
                    />
                </div>
            </header>

            <div className="cliff-toolbar">
                <div className="cliff-view-switch" aria-label="Режим отображения">
                    <button
                        type="button"
                        className={viewMode === 'active' ? 'is-active' : ''}
                        onClick={() => setViewMode('active')}
                    >
                        Активные
                    </button>
                    <button
                        type="button"
                        className={viewMode === 'all' ? 'is-active' : ''}
                        onClick={() => setViewMode('all')}
                    >
                        Все
                    </button>
                </div>
                <div className="cliff-summary">
                    <span>Показано: <b>{summary.total}</b></span>
                    <span>В скважине: <b>{summary.active}</b></span>
                    <button type="button" onClick={() => setUpdateKey((value) => value + 1)}>
                        Обновить
                    </button>
                </div>
            </div>

            <GridCliffList
                isUpdate={updateKey}
                isExport={exportKey}
                viewMode={viewMode}
                onSummaryChange={handleSummaryChange}
            />

            <ModalCliffView
                isOpen={isModalOpen}
                onClose={handleModalClose}
                props={null}
                nodeData={null}
            />
        </div>
    )
}

export default PageCliff
